import { VisualDataModeler } from './components/VisualDataModeler';

function App() {
  return <VisualDataModeler />;
}

export default App;
